<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="150px"
                     class="unitWidth" size="small">
                <el-form-item label="所属工厂">
                    <el-select v-model="fcIdSelected" placeholder="请选择工厂" :clearable="isclear" filterable
                               :disabled="ischeck"
                               @change="fcChange">
                        <el-option
                            v-for="factory in factoryList"
                            :key="factory.value"
                            :label="factory.label"
                            :value="factory.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属车间">
                    <el-select v-model="shopSelected" placeholder="请选择车间" clearable filterable @change="shopChange"
                               :disabled="scopeSelected =='factory'||scopeSelected=='company'">
                        <el-option
                            v-for="shop in shopList"
                            :key="shop.value"
                            :label="shop.label"
                            :value="shop.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工段">
                    <el-select v-model="sectionSelected" placeholder="请选择工段" clearable filterable
                               @change="sectionChange"
                               :disabled="scopeSelected =='shop'|| scopeSelected =='factory'||scopeSelected=='company'">
                        <el-option
                            v-for="section in sectionList"
                            :key="section.value"
                            :label="section.label"
                            :value="section.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产线">
                    <el-select v-model="lineSelected" placeholder="请选择产线" clearable filterable @change="lineChange"
                               :disabled="scopeSelected =='shop'|| scopeSelected =='factory'||scopeSelected=='company'||scopeSelected=='vsm'">
                        <el-option
                            v-for="line in lineList"
                            :key="line.value"
                            :label="line.label"
                            :value="line.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备编号">
                    <el-input v-model.trim="devCode" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="保养工单号">
                    <el-input v-model.trim="pmoNo" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="pmoStatus" placeholder="请选择" clearable @change="searchTable">
                        <el-option label="待接单" value="create"></el-option>
                        <el-option label="待完成" value="wait_complete"></el-option>
                        <el-option label="待验收" value="wait_accept"></el-option>
                        <el-option label="已完成" value="complete"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="保养周期">
                    <el-select v-model="maintainCycle" placeholder="请选择保养周期" clearable @change="searchTable">
                        <el-option label="每周" value="week"></el-option>
                        <el-option label="双周" value="biweekly"></el-option>
                        <el-option label="每月" value="monthly"></el-option>
                        <el-option label="两个月" value="bimonthly"></el-option>
                        <el-option label="每季" value="quarter"></el-option>
                        <el-option label="半年" value="half_a_year"></el-option>
                        <el-option label="每年" value="annually"></el-option>
                		 <el-option label="一年半" value="year_half"></el-option>
                		  <el-option label="两年" value="twoYear"></el-option>
                		   <el-option label="两年半" value="two_year_half"></el-option>
                		    <el-option label="三年" value="three_year"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="isActive" label="是否待执行">
                    <el-select v-model="isShow" placeholder="请选择" clearable @change="searchTable">
                        <el-option label="是" value="0"></el-option>
                        <el-option label="否" value="1"></el-option>
                        <el-option label="全选" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期">
                    <el-date-picker style="width: 60vh" v-model="dateRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" @change="searchTable">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchTable()">查询</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent title="计划工单" ref="LabelContent">
            <div slot="btns">
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                <el-button size="small" type="success" @click="addPlanMantainOrder()" v-for="acc in access"
                           v-if="acc=='PL0001'">新增
                </el-button>
                <el-button size="small" type="success" @click="exportPlanMaintainOrder()">导出</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center">
                <el-table-column prop="fcName" label="工厂名称" width="120"/>
                <el-table-column prop="shopName" label="车间名称" width="120"/>
                <el-table-column prop="sectionName" label="工段名称" width="120"/>
                <el-table-column prop="lineName" label="产线名称" width="120"/>
                <el-table-column prop="devCode" label="设备编号" width="120"/>
                <el-table-column prop="devName" label="设备名称" width="120"/>
                <!--<el-table-column prop="pmoNo" sortable label="计划保养工单" width="180"/>-->
                <el-table-column prop="orderCreateType" label="工单类型" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.orderCreateType == 'manual'">临时</span>
                        <span v-if="scope.row.orderCreateType == 'week'">每周</span>
                        <span v-if="scope.row.orderCreateType == 'biweekly'">双周</span>
                        <span v-if="scope.row.orderCreateType == 'monthly'">每月</span>
                        <span v-if="scope.row.orderCreateType == 'bimonthly'">两个月</span>
                        <span v-if="scope.row.orderCreateType == 'quarter'">每季</span>
                        <span v-if="scope.row.orderCreateType == 'half_a_year'">半年</span>
                        <span v-if="scope.row.orderCreateType == 'annually'">每年</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pmoStatus" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pmoStatus == 'create'">待接单</span>
                        <span v-if="scope.row.pmoStatus == 'wait_complete'">待完成</span>
                        <span v-if="scope.row.pmoStatus == 'wait_accept'">待验收</span>
                        <span v-if="scope.row.pmoStatus == 'complete'">已完成</span>
                    </template>
                </el-table-column>
                <!--                <el-table-column prop="createUser" sortable label="创建用户" width="160"/>-->
                <el-table-column prop="isOverdue" label="是否逾期" width="110">
                    <template slot-scope="scope">
                        <span>{{scope.row.isOverdue ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="响应时间(分)" width="110">
                    <template slot-scope="scope">
                        <span>
                            {{scope.row.hasOwnProperty('pmoActionTime') ?
                            parseInt((new Date(scope.row.pmoActionTime).getTime() - new Date(scope.row.createTime).getTime()) / 1000 / 60) : ''}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="pmoPlanTime" label="计划执行月份" :formatter="dateFormat" width="160"/>
                <el-table-column prop="planUserName" label="计划人员" width="160"/>
                <el-table-column prop="actionUserName" label="计划执行人员" width="160"/>
                <el-table-column prop="pmoPlanStartTime" label="计划执行开始时间" width="160"/>
                <el-table-column prop="pmoPlanEndTime" label="计划执行结束时间" width="160"/>
                <el-table-column prop="pmoRatedHour" label="计划工时" width="160"/>
                <el-table-column prop="maintainActualStart" label="计划实际开始时间" width="160"/>
                <el-table-column prop="maintainActualEnd" label="计划实际结束时间" width="160"/>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                        <!--<i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false),updatehOpen(scope.row)" />
                        <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" />-->
                        <i class="editBtn iconfont u-youjianbianji" @click="EditPlanMantainOrder(scope.row)"
                           v-for="acc in access" v-if="acc=='PL0002'"/>
                        <i class="delBtn iconfont u-shanchu" @click="deletePlanMantainOrder(scope.row)"
                           v-for="acc in access" v-if="acc=='PL0003'"/>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
    </div>
</template>

<script>
    import { getPlanMaintainOrder } from '../../../libs/api'
    import moment from 'moment'

    export default {
        name: 'planMantainOrder',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                devCode: '',
                pmoNo: '',
                pmoStatus: '',
                dateRange: '',
                maintainCycle: '',
                isShow: '0',
                tableData: [],
                access: [],
                factoryTree: [],
                fcIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                userInfo: {},
                ischeck: true,
                scopeDisabled: true,
                role: [],
                scopeSelected: '',
                isclear: false,
                planArray: {},
                isActive: false
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                //如果为宁波工厂，显示查询选项
                if(userInfo.fcCode != undefined && userInfo.fcCode == 'NJSS'){
                    this.isActive = true
                }else if(userInfo.empNumber != undefined && userInfo.empNumber == 'admin'){
                    this.isActive = true
                }
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            this.init()
        },
        activated() {
            this.init()
        },
        methods: {
            init() {
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.scopeDisabled = false
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getData()
            },
            dateFormat: function(row, column) {
                var date = row[column.property]
                if (date == undefined) {
                    return ''
                }

                return moment(date).format('YYYY-MM-DD')
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            fcChange: function() {
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
                // this.getData();
                this.searchTable()
            },
            shopChange: function() {
                this.sectionSelected = ''
                this.lineSelected = ''
                // this.getData();
                this.searchTable()
            },
            sectionChange: function() {
                this.lineSelected = ''
                // this.getData();
                this.searchTable()
            },
            lineChange: function() {
                // this.getData();
                this.searchTable()
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                        }
                        if (self.$route.params.planSpe != undefined && self.$route.params.planSpe != '') {
                            self.planArray = self.$route.params.planSpe
                            if (self.planArray.hasOwnProperty('fcCode')) {
                                if (self.factoryTree[i].deptCode == self.planArray.fcCode) {
                                    self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                                    if (self.planArray.hasOwnProperty('shopCode')) {
                                        var shops = JSON.parse(self.fcIdSelected).child
                                        for (let j = 0; j < shops.length; j++) {
                                            if (shops[j].hasOwnProperty('deptCode')) {
                                                if (shops[j].deptCode == self.planArray.shopCode) {
                                                    self.shopSelected = JSON.stringify(shops[j])
                                                    if (self.planArray.hasOwnProperty('sectionCode')) {
                                                        var sections = JSON.parse(self.shopSelected).child
                                                        for (let k = 0; k < sections.length; k++) {
                                                            if (sections[k].hasOwnProperty('deptCode')) {
                                                                if (sections[k].deptCode == self.planArray.sectionCode) {
                                                                    self.sectionSelected = JSON.stringify(sections[k])
                                                                    if (self.planArray.hasOwnProperty('lineCode')) {
                                                                        var lines = JSON.parse(self.sectionSelected).child
                                                                        for (let l = 0; l < lines.length; l++) {
                                                                            if (lines[l].hasOwnProperty('deptCode')) {
                                                                                if (lines[l].deptCode == self.planArray.lineCode) {
                                                                                    self.lineSelected = JSON.stringify(lines[l])
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (self.$route.params.planSpe != undefined && self.$route.params.planSpe != '') {
                        self.devCode = self.planArray.devCode
                        self.pmoNo = self.planArray.pmoNo
                    }
                    this.searchTable()
                })
            },
            addPlanMantainOrder() {
                this.$router.push({ path: '/addPlanMantainOrder' })
            },
            EditPlanMantainOrder(row) {
                this.$router.push({
                    name: 'editPlanMantainOrder',
                    params: {
                        planMantainOrder: row
                    }
                })
            },
            deletePlanMantainOrder(row) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                url: this.$api.delPlanMaintainOrder,
                                params: {
                                    pmoId: row.pmoId,
                                    pmoNo: row.pmoNo
                                }
                            })
                            .then(response => {
                                this.searchTable()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.searchTable()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.searchTable()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            async exportPlanMaintainOrder() {
                let queryParams = {}

                if (this.devCode != null && this.devCode != '') {
                    queryParams['devCode'] = this.devCode
                }
                if (this.pmoNo != null && this.pmoNo != '') {
                    queryParams['pmoNo'] = this.pmoNo
                }
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                if (this.shopSelected != undefined && this.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(this.shopSelected).deptCode
                }
                if (this.sectionSelected != undefined && this.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
                }
                if (this.lineSelected != undefined && this.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(this.lineSelected).deptCode
                }
                if (this.pmoStatus != undefined && this.pmoStatus != '') {
                    queryParams['pmoStatus'] = this.pmoStatus
                }
                if (this.maintainCycle != undefined && this.maintainCycle != '') {
                    queryParams['orderCreateType'] = this.maintainCycle
                }
                if (this.isShow != undefined && this.isShow != '') {
                    queryParams['isShow'] = this.isShow
                }
                if (this.dateRange != null && this.dateRange != '') {
                    if (this.dateRange.length > 0 && this.dateRange[0] != '') {
                        queryParams['startTime'] = this.dateFormatTo(this.dateRange[0]) + ' 00:00:00'
                        queryParams['endTime'] = this.dateFormatTo(this.dateRange[1]) + ' 23:59:59'
                    }
                }
                let options = {
                    method: 'POST',
                    params: queryParams,
                    url: this.$api.exportPlanMaintainOrder,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                this.$http.config.timeout = 120000
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '计划工单信息'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                if (this.devCode != null && this.devCode != '') {
                    queryParams['devCode'] = this.devCode
                }
                if (this.pmoNo != null && this.pmoNo != '') {
                    queryParams['pmoNo'] = this.pmoNo
                }
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                if (this.shopSelected != undefined && this.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(this.shopSelected).deptCode
                }
                if (this.sectionSelected != undefined && this.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
                }
                if (this.lineSelected != undefined && this.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(this.lineSelected).deptCode
                }
                if (this.pmoStatus != undefined && this.pmoStatus != '') {
                    queryParams['pmoStatus'] = this.pmoStatus
                }
                if (this.maintainCycle != undefined && this.maintainCycle != '') {
                    queryParams['orderCreateType'] = this.maintainCycle
                }
                if (this.isShow != undefined && this.isShow != '') {
                    queryParams['isShow'] = this.isShow
                }
                if (this.dateRange != null && this.dateRange != '') {
                    if (this.dateRange.length > 0 && this.dateRange[0] != '') {
                        queryParams['startTime'] = this.dateFormatTo(this.dateRange[0]) + ' 00:00:00'
                        queryParams['endTime'] = this.dateFormatTo(this.dateRange[1]) + ' 23:59:59'
                    }
                }
                let options = {
                    method: 'GET',
                    params: queryParams,
                    url: this.$api.getPlanMaintainOrder
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            dateFormatTo(date) {
                return moment(date).format('YYYY-MM-DD')
            }
        }
    }
</script>

<style scoped>

</style>
